import React, { useState, useEffect, useContext, useRef } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
// import { RadioButton } from "primereact/radiobutton";
// import { InputText } from "primereact/inputtext";
// import { TabView, TabPanel } from "primereact/tabview";
import GlobalContext from "../../../isp._comun/iu/contexto/GlobalContext";

import Dialogo               from "../../../isp._comun/iu/_principal/componentes/layouts/Dialogo";
import { ModosOp }           from "../../../isp._comun/iu/_principal/constantesIuPrin";

// import VentanaClienteAFacturar from "../../reductores/ventanas/VentanaClienteAFacturar";
import VentanaPlan from "../../reductores/ventanas/VentanaPlan";
import BuscarPlanes from "../../reductores/acciones/dispatch/BuscarPlanes";

import { UnidadAnchoBandaLabel, UnidadPlanLabel } from "./žconstantesIuLayoutPlanes";

const DialogoQueryPlanesLayout = ({
    ventana,
    dispatchQ,
    estadoQ,
    buscarPlanes,
}) => {
    // const { dispatchPrincipal, estadoPrin } = useContext(GlobalContext);
    const { 
        // dispatchPrincipal, 
        // estadoPrin,
        abrirVentana,
        // posicionarVentanaTop,
        eliminarVentana,
        // cargarYMostrarVentana,
        // getVentanaIdenticaSiYaExisteEnLalista,
    } = useContext(GlobalContext);
    // const isMounted = useRef(false);

    /*  useEffect(() => {
        if (isMounted.current) {
            buscarClientesAFacturar();
        } else {
            isMounted.current = true;
        }
    }, [estadoQ.flag.sensorDeAccionABuscar]); */

    useEffect(() => {
        if (estadoQ.flag.procesandoComando) {
            buscarPlanes.ejecutar({});
        }
        return ()=>{buscarPlanes.cancelar()};
    }, [estadoQ.flag.procesandoComando]);


    const dobleClickEnFila = (eventoSyn) => {
        const nuevaVentana = VentanaPlan.nuevaVentanaEnModoOk(eventoSyn.data.idPlan);
        abrirVentana(nuevaVentana);
        // const nuevaVentana = new VentanaPlan();
        // nuevaVentana.estadoComp.flag.modoOperacion = ModosOp.OK;
        // nuevaVentana.estadoComp.domain.screen.idPlan = eventoSyn.data.idPlan;
        
        // // const ventanaAAbrir = MostrarVentana.getVentanaExistenteEnLaLista(estadoPrin, nuevaVentana);
        // const ventanaAAbrir = getVentanaIdenticaSiYaExisteEnLalista(nuevaVentana);

        // if (ventanaAAbrir) {
        //     ventana.ventanaCargando = ventanaAAbrir;
        //     posicionarVentanaTop(ventanaAAbrir);
        //     return;
        // }
        
        // nuevaVentana.estadoComp.flag.modal = true;
        // nuevaVentana.estadoComp.flag.cargandoEntidad = true;
        // ventana.ventanaCargando = nuevaVentana;
        // cargarYMostrarVentana(nuevaVentana);
    };

    const footer = (
        <div>
            <Button
                label={"  Buscar  "}
                icon="pi pi-search"
                onClick={(eventoSynDom) => {
                    dispatchQ(new BuscarPlanes());
                    // buscarClientesAFacturar();
                    eventoSynDom.stopPropagation();
                }}
                loading={estadoQ.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            />
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={(eventoSynDom) => {
                    eliminarVentana(ventana);
                    eventoSynDom.stopPropagation();
                }}
                disabled={estadoQ.flag.procesandoComando}
                // className="w-32"
            />
        </div>
    );

    const header = {
        elementoReact: (
            <p className="p-2 bg-gradient-to-r from-purple-100">Lista de Planes</p>
        ),
        enProgreso: false,
        // enProgreso: estadoQ.flag.procesandoComando,
    };

    /* const tipoPlanBodyTemplate=(rowData) => {
        return TipoPlanLabel[rowData.tipoPlan];
    } */

    const unidadBodyTemplate=(rowData) => {
        return UnidadPlanLabel[rowData.udm];
    }
    
    const unidadABBodyTemplate=(rowData) => {
        return UnidadAnchoBandaLabel[rowData.unidAnchoBanda];
    }

    const dialogo = (
        <Dialogo
            // visible={true}
            // // style={{ width: "50vw"}}
            // modal={false}
            // onHide={() => onClick("CERRAR_DIALOGO")}
            // onShow={onShow}
            // onClick={() => onClick("CLICK_PANEL")}
            // keepInViewport={false}
            // maskStyle={{ zIndex: posicionZ }}
            ventana={ventana}
            cabecera={header}
            pie={footer}
            estilo={{ width: "60rem", minHeight: "70vh", top: "15vh", margin: "0" }}
            posicionZ={ventana.posicionZ}
            modal={false}
        >
            <DataTable
                value={estadoQ.data}
                paginator
                rows={8}
                showGridlines
                stripedRows
                size="small"
                selectionMode="single"
                // autoLayout={true}
                // autoLayout
                // autoLayout={false}
                // responsiveLayout="stack"
                // responsiveLayout="scroll"
                scrollable
                scrollDirection="both"
                emptyMessage="No se encontró Planes."
                totalRecords={100}
                // columnResizeMode="expand"
                columnResizeMode="fit"
                // resizableColumns
                tableStyle={{ minHeight: "40vh" }}
                onRowDoubleClick={dobleClickEnFila}
            >
                <Column
                    field="idPlan"
                    header="Id. Plan"
                    style={{ width: "10%" }}
                    // bodyStyle={{ "width": "1%" }}
                    // unstyled
                ></Column>
                {/* <Column
                    field="tipoPlan"
                    header="Tipo Plan"
                    body={tipoPlanBodyTemplate}
                    style={{ width: "14%" }}
                ></Column> */}
                <Column field="nombre" header="Nombre" style={{ width: "46%" }}></Column>
                <Column field="precio" header="Precio / unit" style={{ width: "10%" }}></Column>
                <Column field="moneda" header="Moneda" style={{ width: "9%" }}></Column>
                
                <Column 
                    field="udm" 
                    header="Unidad"
                    body={unidadBodyTemplate} 
                    style={{ width: "9%" }}
                ></Column>
                <Column field="anchoBanda" header="A / B" style={{ width: "8%" }}></Column>
                <Column 
                    field="unidAnchoBanda" 
                    header="Unidad A/B"
                    body={unidadABBodyTemplate} 
                    style={{ width: "8%" }}
                ></Column>
                {/* <Column field="udm" header="Udm" style={{ width: "25%" }}></Column> */}
                {/* <Column field="dni" header="DNI" style={{ minWidth: "1rem" }}></Column>
                <Column field="ptp" header="PTP" style={{ minWidth: "1rem" }}></Column>
                <Column
                    field="carnetExt"
                    header="C. Extranjería"
                    style={{ minWidth: "1rem" }}
                ></Column>
                <Column field="pasaporte" header="Pasaporte" style={{ minWidth: "1rem" }}></Column> */}
                {/* <Column
                    field="razonSocial"
                    header="Razón Social"
                    style={{ width: "25%" }}
                    unstyled
                ></Column> */}
            </DataTable>
        </Dialogo>
    );

    return dialogo;
};

export default DialogoQueryPlanesLayout;
